<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { devices_settings } from 'src/stores/device-runtime/status';
	//Helpers
	import { get_local_ip, real_id } from '../../../../../helpers/interface_helpers';
	import { getNumberInputConfig } from '../../../../../helpers/number_input_helpers';
	//Services
	import { format } from '../../../../../services/i18n';
	import { localReq, postReq } from '../../../../../services/http';
	//Stores
	//Design system compoennts
	import { Button, Input, Text, toast } from '@Shelly/shelly-design-system';
	export let device;

	const id = real_id(device.id);

	const settings = readDeviceSettings(id);
	let min = -2,
		max = 2;
	let value = settings?.adcs[0].offset;
	let cache = value;
	let loading = false;
	let localIp = get_local_ip(id);

	const setAdcOffset = async () => {
		if (cache !== value) {
			let res;
			loading = true;
			if (localIp) {
				res = await localReq(device, `${localIp}/settings/adc/0`, 'post', {
					offset: value,
				});
			} else {
				res = await postReq(`/device/generic_command`, {
					id: id,
					command: 'adc_offset',
					payload: JSON.stringify({ id: 0, offset: +value }),
				});
			}

			if (res.isok) {
				toast.open({
					type: 'success',
					title:
						$format('adc_offset_set_scc_toast', { values: { value } }) ||
						`Adc offset was changed to ${value}v`,
				});
				settings.adcs[0].offset = value;
				devices_settings.update_devices_settings(id, settings);
				cache = value;
			} else {
				toast.open({ type: 'danger', title: $format('error_global') });
				value = cache;
			}
			loading = false;
		}
	};
</script>

<Text styleType="body-small" class="mb-s">
	{$format('adc_set_offset', { values: { min, max } })}
</Text>
<Input
	{...getNumberInputConfig()}
	class="mb-s"
	bind:value
	{min}
	{max}
	step={0.1}
	on:enter={setAdcOffset}
	id="input-f6dnt1v"
	aria-label={$format('adc_set_offset', { values: { min, max } })}
/>
<Button class="mt-s" size="m" width="full" on:click={setAdcOffset}>{$format('button_save')}</Button>
